export default __webpack_public_path__ + "static/media/ChickenWings.7894f00c.jpg";